import { createTheme } from '@mui/material/styles';


export const brand = {
  bg: '#000000',
  s1: '#0a0a0a',
  s2: '#141414',
  s3: '#1e1e1e',
  border: '#2a2a2a',
  fg: '#f5f5f5',
  fg2: '#737373',
  fg3: '#525252',
  primary: '#2d77cf',
  primaryDark: '#1e5fad',
  primaryLight: '#5192d8',
  accent: '#00d4ff',
  bolo: '#c41e1e',
  errorText: '#ef8080',
  errorBorder: '#c04545',
};

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: brand.bg,
      paper: brand.s1,
    },
    text: {
      primary: brand.fg,
      secondary: brand.fg2,
    },
    primary: {
      main: brand.primary,
      dark: brand.primaryDark,
      light: brand.primaryLight,
      contrastText: '#ffffff',
    },
    secondary: {
      main: brand.accent,
      contrastText: '#000000',
    },
    error: {
      main: brand.errorText,
    },
    divider: brand.border,
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    h1: { fontFamily: "'Outfit', system-ui, sans-serif", fontWeight: 600, letterSpacing: '-0.045em' },
    h2: { fontFamily: "'Outfit', system-ui, sans-serif", fontWeight: 600, letterSpacing: '-0.035em' },
    h3: { fontFamily: "'Outfit', system-ui, sans-serif", fontWeight: 600, letterSpacing: '-0.03em' },
    h4: { fontFamily: "'Outfit', system-ui, sans-serif", fontWeight: 600, letterSpacing: '-0.03em' },
    h5: { fontFamily: "'Outfit', system-ui, sans-serif", fontWeight: 600, letterSpacing: '-0.025em' },
    h6: { fontFamily: "'Outfit', system-ui, sans-serif", fontWeight: 600, letterSpacing: '-0.02em' },
    button: { fontFamily: "'Outfit', system-ui, sans-serif", fontWeight: 600, textTransform: 'none' },
    overline: { fontFamily: "'Outfit', system-ui, sans-serif", fontWeight: 500, letterSpacing: '0.16em' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: brand.bg },
        a: { color: brand.primary },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0,0,0,0.72)',
          backdropFilter: 'saturate(160%) blur(18px)',
          borderBottom: `1px solid ${brand.border}`,
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingLeft: 20,
          paddingRight: 20,
        },
        containedPrimary: {
          backgroundColor: brand.primary,
          '&:hover': { backgroundColor: brand.primaryDark },
        },
        outlined: {
          borderColor: brand.border,
          color: brand.fg,
          '&:hover': { borderColor: brand.primary, backgroundColor: 'rgba(45,119,207,0.08)' },
        },
        text: {
          color: brand.fg2,
          '&:hover': { color: brand.fg, backgroundColor: 'rgba(255,255,255,0.06)' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: brand.s1,
          border: `1px solid ${brand.border}`,
          borderRadius: 18,
          backgroundImage: 'none',
          transition: 'border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: brand.s3,
          borderRadius: 10,
          '& fieldset': { borderColor: brand.border },
          '&:hover fieldset': { borderColor: brand.fg2 },
          '&.Mui-focused fieldset': { borderColor: brand.primary },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontFamily: "'Outfit', system-ui, sans-serif",
          fontWeight: 500,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${brand.border}`,
        },
        head: {
          color: brand.fg2,
          fontFamily: "'Outfit', system-ui, sans-serif",
          fontWeight: 600,
          fontSize: '0.75rem',
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: brand.s1,
          border: `1px solid ${brand.border}`,
          borderRadius: 14,
          backgroundImage: 'none',
          '&:before': { display: 'none' },
          '&.Mui-expanded': { margin: '0 0 16px 0' },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: brand.primary,
          '&:hover': { color: brand.primaryLight },
        },
      },
    },
  },
});

export default theme;
